import { Collapse } from 'react-bootstrap';

import { EditableSettings } from 'components/EditableSettings/EditableSettings';
import { Input, ToggleLabel } from 'components/FormComponents';

import { ExtraOptions } from '../ExtraOptions/ExtraOptions';

export const DateSettings = ({
  register,
  name,
  field,
  allowDescription = true,
  extraOptions = null,
}) => (
  <EditableSettings title="Settings" className="u-margin-top" open={true}>
    <ToggleLabel register={register} name={`${name}.required`} label="Required" />
    <div className="u-divider u-margin-y--small" />
    <ToggleLabel
      register={register}
      name={`${name}.options.useDefault`}
      label='Use "current" as default'
    />
    {allowDescription && (
      <>
        <div className="u-divider u-margin-y--small" />
        <ToggleLabel register={register} name={`${name}.use_description`} label="Add description" />
        <Collapse in={field.use_description}>
          <div>
            <Input
              register={register}
              name={`${name}.description`}
              className="u-margin-top--small"
              placeholder="Enter description..."
            />
          </div>
        </Collapse>
      </>
    )}
    <ExtraOptions register={register} name={name} options={extraOptions} />
  </EditableSettings>
);
